export const WorkData = [
  {
    company: "AWS Certified Developer - Associate",
    designation: "Amazon",
    dateJoining: "2023",
    dateEnd: "2026",
    companyLogo: require("../../assets/aws.png"),
    work: "Proficient in designing, developing, and deploying cloud solutions using EC2, S3, DynamoDB, and related AWS services.",
  },
  {
    company: "Associate Cloud Engineer",
    designation: "Google Cloud",
    dateJoining: "2024",
    dateEnd: "2027",
    companyLogo: require("../../assets/gcp.png"),
    work: "Skilled in deploying, managing, and maintaining solutions on GCP.",
  },
];
